import { render, staticRenderFns } from "./BaseSwitch.vue?vue&type=template&id=c4226da6&"
import script from "./BaseSwitch.vue?vue&type=script&lang=js&"
export * from "./BaseSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports